package kz.dentalcrm.app.screens.appointments.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface AppointmentsViewSideEffect : ViewSideEffect {
    data class NavigateToEdit(val id: Int) : AppointmentsViewSideEffect
}